import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import Login from '@/views/AppLogin.vue'
import InspectionHome from '@/views/AppHome.vue'
import DeviceAuth from '@/views/DeviceAuth.vue'
import InspectionParent from '@/views/inspection/InspectionParent.vue'
import InspectionBasicInfo from '@/views/inspection/InspectionBasicInfo.vue'
import InspectionBuildingInfo from '@/views/inspection/InspectionBuildingInfo.vue'
import InspectionStep1 from '@/views/inspection/InspectionStep1.vue'
import InspectionStep2 from '@/views/inspection/InspectionStep2.vue'
import InspectionResult from '@/views/inspection/InspectionResult.vue'
import { GRADE_TYPE } from '@/constants/router/contract'
import { ROUTER_PATHS } from '@/constants/router/paths'
import { ROUTER_NAMES } from '@/constants/router/names'
import {
  deviceGuard,
  homeGuard,
  inspectionBasicInfoGuard,
  inspectionBuildingInfoGuard,
  inspectionResultGuard,
  inspectionRootGuard,
  inspectionStep1Guard,
  inspectionStep2Guard
} from './guard/guard'
import { ACTION_TYPE, EMERGENCY_SCOPE } from '@/constants/router/auth'
import { useRouterStore } from '@/stores/routerStore'
import { storeToRefs } from 'pinia'

export const routes: RouteRecordRaw[] = [
  {
    path: ROUTER_PATHS.login,
    name: ROUTER_NAMES.login,
    component: Login,
    meta: {
      requiresAuth: false, // [MiiaFW] 認証必須フラグ
      requiredGrade: GRADE_TYPE.free
    }
  },
  {
    path: ROUTER_PATHS.deviceAuth,
    name: ROUTER_NAMES.deviceAuth,
    component: DeviceAuth,
    meta: {
      requiresAuth: true,
      requiredAuthorities: []
    },
    beforeEnter: deviceGuard
  },
  {
    path: ROUTER_PATHS.home,
    name: ROUTER_NAMES.home,
    component: InspectionHome,
    meta: {
      requiresAuth: true,
      requiredAuthorities: []
    },
    beforeEnter: homeGuard
  },
  {
    path: ROUTER_PATHS.inspection.root,
    name: ROUTER_NAMES.inspection.root,
    component: InspectionParent,
    meta: {
      requiresAuth: true,
      requiredAuthorities: [{ scope: EMERGENCY_SCOPE.riskAssessment, actions: [ACTION_TYPE.write] }]
    },
    beforeEnter: inspectionRootGuard,
    children: [
      // 子ルートをここに定義
      {
        path: ROUTER_PATHS.inspection.basicInfo,
        name: ROUTER_NAMES.inspection.basicInfo,
        component: InspectionBasicInfo,
        meta: {
          requiresAuth: true,
          requiredAuthorities: [
            { scope: EMERGENCY_SCOPE.riskAssessment, actions: [ACTION_TYPE.write] }
          ]
        },
        beforeEnter: inspectionBasicInfoGuard
      },
      {
        path: ROUTER_PATHS.inspection.buildingInfo,
        name: ROUTER_NAMES.inspection.buildingInfo,
        component: InspectionBuildingInfo,
        meta: {
          requiresAuth: true,
          requiredAuthorities: [
            { scope: EMERGENCY_SCOPE.riskAssessment, actions: [ACTION_TYPE.write] }
          ]
        },
        beforeEnter: inspectionBuildingInfoGuard
      },
      {
        path: ROUTER_PATHS.inspection.step1,
        name: ROUTER_NAMES.inspection.step1,
        component: InspectionStep1,
        meta: {
          requiresAuth: true,
          requiredAuthorities: [
            { scope: EMERGENCY_SCOPE.riskAssessment, actions: [ACTION_TYPE.write] }
          ]
        },
        beforeEnter: inspectionStep1Guard
      },
      {
        path: ROUTER_PATHS.inspection.step2,
        name: ROUTER_NAMES.inspection.step2,
        component: InspectionStep2,
        meta: {
          requiresAuth: true,
          requiredAuthorities: [
            { scope: EMERGENCY_SCOPE.riskAssessment, actions: [ACTION_TYPE.write] }
          ]
        },
        beforeEnter: inspectionStep2Guard
      },
      {
        path: ROUTER_PATHS.inspection.result,
        name: ROUTER_NAMES.inspection.result,
        component: InspectionResult,
        meta: {
          requiresAuth: true,
          requiredAuthorities: [
            { scope: EMERGENCY_SCOPE.riskAssessment, actions: [ACTION_TYPE.write] }
          ]
        },
        beforeEnter: inspectionResultGuard
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: routes
})

router.beforeEach((_to, from, next) => {
  const routerStore = useRouterStore()
  const { previousPath } = storeToRefs(routerStore)
  previousPath.value = from.matched.length === 0 ? from.path : from.matched[0].path
  next()
})

export default router
